import "./static/map.jpg";

import "./location_popup.css";
